/**
 * @param {number} strength
 * @returns {SpacingType}
 */
function getSeparatorSpacing(strength) {
  if (strength === 1) return 'spacing400';
  if (strength === 2) return 'spacing500';
  if (strength === 3) return 'spacing600';
  if (strength === 4) return 'spacing700';
  if (strength === 5) return 'spacing800';
  return 'spacing400';
}

export default getSeparatorSpacing;
